import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import * as jwt from 'jsonwebtoken';
import UserService from '../../service/UserService';
import loginService from '../../service/login';
import { bindActionCreators } from 'redux';
import { BallClipRotate } from 'react-pure-loaders';
import {
  AddUser,
  LoginSagaAction,
  checkUserExist,
} from '../../sagas/saga-actions';

const userservice = new UserService();

class LoginWithEhr extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toastId: null,
    };
  }
  async componentWillMount() {
    try {
      const params = new URLSearchParams(this.props.location.search);
      const code = params.get('code');
      const userDetails = await userservice.getUserDetailsWithEhr({
        code: code,
        ehrName: loginService.getEhrName(),
      });
      if (userDetails && userDetails.token) {
        await loginService.doLogin(userDetails.token);
        const decodedTokens = jwt.decode(userDetails.token, { complete: true });
        this.props.checkUserExist(decodedTokens.payload);
        this.props.LoginSagaAction(decodedTokens.payload);
        this.props.history.push('/chat');
      }
    } catch (err) {
      this.props.history.push({
        pathname: '/',
        state: { detail: 'Something went wrong,Please try again.' },
      });
    }
  }
  render() {
    return (
      <Fragment>
        <div className="loader-wrapper">
          <BallClipRotate color={'#a50731'} loading={true} />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  patients: state.patients,
});

const mapDispatchToProps = (dispatch) => ({
  LoginSagaAction: bindActionCreators(LoginSagaAction, dispatch),
  AddUser: bindActionCreators(AddUser, dispatch),
  checkUserExist: bindActionCreators(checkUserExist, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginWithEhr);
